(() => {
  if (window.PeakStyleLoading) return;

  const indicator = document.getElementById('PeakStyleLoadingIndicator');
  if (!indicator) return;

  const DELAY = 250;
  const MAX_VISIBLE_MS = 15000;
  let pending = 0;
  let collectionFilterPending = 0;
  let timer = null;
  let safetyTimer = null;
  let navigation = false;

  const setCollectionFilterBusy = (busy) => {
    const productGrid = document.getElementById('ProductGridContainer');
    if (!productGrid) return;
    if (busy) {
      productGrid.setAttribute('aria-busy', 'true');
    } else {
      productGrid.removeAttribute('aria-busy');
    }
  };

  const forceHide = () => {
    pending = 0;
    navigation = false;
    window.clearTimeout(timer);
    window.clearTimeout(safetyTimer);
    safetyTimer = null;
    indicator.classList.remove('is-visible', 'is-navigation');
    indicator.setAttribute('aria-hidden', 'true');
  };

  const armSafetyTimer = () => {
    window.clearTimeout(safetyTimer);
    safetyTimer = window.setTimeout(() => {
      if (!indicator.classList.contains('is-visible')) return;
      console.warn('PeakStyle loading indicator released by safety timeout.');
      forceHide();
    }, MAX_VISIBLE_MS);
  };

  const show = (options = {}) => {
    pending += 1;
    navigation = navigation || options.navigation === true;
    window.clearTimeout(timer);
    armSafetyTimer();
    if (indicator.classList.contains('is-visible')) {
      indicator.classList.toggle('is-navigation', navigation);
      return;
    }
    const delay = options.immediate
      ? 0
      : Number.isFinite(options.delay)
        ? Math.max(0, options.delay)
        : DELAY;
    timer = window.setTimeout(() => {
      if (!pending) return;
      indicator.classList.toggle('is-navigation', navigation);
      indicator.classList.add('is-visible');
      indicator.setAttribute('aria-hidden', 'false');
    }, delay);
  };

  const hide = () => {
    pending = Math.max(0, pending - 1);
    if (pending) return;
    navigation = false;
    window.clearTimeout(timer);
    window.clearTimeout(safetyTimer);
    safetyTimer = null;
    indicator.classList.remove('is-visible', 'is-navigation');
    indicator.setAttribute('aria-hidden', 'true');
  };

  const reset = () => {
    pending = 0;
    collectionFilterPending = 0;
    navigation = false;
    window.clearTimeout(timer);
    window.clearTimeout(safetyTimer);
    safetyTimer = null;
    indicator.classList.remove('is-visible', 'is-navigation');
    indicator.setAttribute('aria-hidden', 'true');
    setCollectionFilterBusy(false);
  };

  const getRequestUrl = (input) => {
    try {
      return new URL(typeof input === 'string' ? input : input.url, window.location.href);
    } catch (error) {
      return null;
    }
  };

  const isForegroundRequest = (input) => {
    const url = getRequestUrl(input);
    if (!url || url.origin !== window.location.origin) return false;
    const path = url.pathname;
    if (/\/recommendations\/products/.test(path)) return false;
    if (/\.js$/.test(path)) return false;
    if (/\/search\/suggest/.test(path)) return true;
    if (/\/cart\/(add|change|update|clear)/.test(path)) return true;
    if (url.searchParams.has('option_values')) return true;
    if (url.searchParams.has('section_id')) return true;
    if (url.searchParams.has('sections')) return true;
    return false;
  };

  const isCollectionFilterRequest = (input) => {
    const url = getRequestUrl(input);
    if (!url || url.origin !== window.location.origin) return false;
    return /^\/collections(?:\/|$)/.test(url.pathname) && url.searchParams.has('section_id');
  };

  const nativeFetch = window.fetch.bind(window);
  window.fetch = function peakStyleFetch(input, init) {
    const foreground = isForegroundRequest(input);
    const collectionFilter = foreground && isCollectionFilterRequest(input);

    if (collectionFilter) {
      collectionFilterPending += 1;
      setCollectionFilterBusy(true);
    }

    // Collection facet requests already have a local grid loader. Do not add
    // the full-screen global overlay as a second loading layer.
    if (foreground && !collectionFilter) {
      show();
    }

    return nativeFetch(input, init).finally(() => {
      if (collectionFilter) {
        collectionFilterPending = Math.max(0, collectionFilterPending - 1);
        if (!collectionFilterPending) setCollectionFilterBusy(false);
      }
      if (foreground && !collectionFilter) hide();
    });
  };

  const shouldHandleLink = (event, anchor) => {
    if (!anchor || event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    if (anchor.hasAttribute('download')) return false;
    if (anchor.closest('[data-product-quickview], drawer-opener, modal-opener')) return false;
    let url;
    try { url = new URL(anchor.href, window.location.href); } catch (error) { return false; }
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;
    if (/^(mailto:|tel:|javascript:)/i.test(anchor.getAttribute('href') || '')) return false;
    return true;
  };

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!shouldHandleLink(event, anchor)) return;
    if (document.querySelector('.f-page-transition')) return;
    show({ navigation: true });
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    if (form.closest('product-form, predictive-search, facet-filters-form')) return;
    show({ navigation: true });
  }, true);

  window.addEventListener('pageshow', reset);
  window.addEventListener('pagehide', () => show({ navigation: true, immediate: true }));

  window.PeakStyleLoading = { show, hide, reset, forceHide };
})();